export default __webpack_public_path__ + "static/media/ai-drop-zone-default.e7cb6e84.svg";